"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PayPal } from './paypal';
/**
 * PayPalCheckout component renders a PayPal payment button for the shopping cart. It requires the PayPal client ID, checkout data, and an onApprove callback function as props. The component will render the PayPal button and handle the payment process when the user clicks it.
 *
 * @param: payPalClientID - Optional PayPal client ID to enable the PayPal checkout button.
 * @param: checkoutData - An object containing the details of the checkout, such as total amount, currency, and shipping information.
 * @param: onApprove - A callback function that will be called when the payment is approved by the user. It receives the payment details as an argument.
 * @returns: A React component that renders the PayPal payment button.
 *
*/
PayPalCheckout.propTypes = {
    payPalClientID: PropTypes.string.isRequired,
    payPalSecret: PropTypes.string,
    payPalApiBaseUrl: PropTypes.string,
    checkoutData: PropTypes.object.isRequired,
    onApprove: PropTypes.func.isRequired,
};
export function PayPalCheckout(props) {
    if (!props.payPalClientID) {
        return null;
    }
    return (_jsx("div", { className: "pix-cart-payment-method", children: _jsx(PayPal, { payPalClientID: props.payPalClientID, payPalSecret: props.payPalSecret, payPalApiBaseUrl: props.payPalApiBaseUrl, checkoutData: props.checkoutData, onApprove: props.onApprove }) }));
}
export function renderPayPalThankYou(orderData, config) {
    const payment = orderData?.purchase_units?.[0]?.payments?.captures?.[0];
    const currency = config?.integrations?.shoppingcart?.currency || payment?.amount?.currency_code || 'USD';
    if (!payment) {
        const summary = JSON.stringify(orderData, null, 2);
        return (_jsxs("div", { children: [_jsx("h3", { children: "Thank you for your payment!" }), _jsx("pre", { style: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' }, children: summary })] }));
    }
    return (_jsxs("div", { children: [_jsx("h3", { children: "Thank you for your payment!" }), "Payment ID : ", payment.id, " ", _jsx("br", {}), "Status : ", payment.status, " ", _jsx("br", {}), "Amount : $", payment.amount?.value + " " + currency, " ", _jsx("br", {}), "Created : ", payment.create_time, " ", _jsx("br", {})] }));
}
